import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

/**
 * This hook is used to get a calculation by its ID.
 * @param calculationId - The ID of the calculation.
 * @returns The calculation and the context.
 */
export function useCalculation(calculationId: string) {
	/** Hooks */
	const query = useQuery({
		queryKey: ["calculation", calculationId],
		queryFn: async () => {
			const response = await client.calculations[":calculationId"].$get({
				param: { calculationId },
			});
			const data = await responseHandler(response);
			return data;
		},
	});

	return {
		...query,
		calculation: query.data?.calculation,
		context: query.data?.context,
	};
}
